import { render, staticRenderFns } from "./CreateRule.vue?vue&type=template&id=361254f9&scoped=true&"
import script from "./CreateRule.vue?vue&type=script&lang=js&"
export * from "./CreateRule.vue?vue&type=script&lang=js&"
import style0 from "./CreateRule.vue?vue&type=style&index=0&id=361254f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361254f9",
  null
  
)

export default component.exports